import AgTechTitleDetailContentCard from '@agtech/web/components/Cards/AgTechTitleDetailContentCard'
import AgTechCardCollection, { AgTechCardCollectionProps } from '@agtech/web/components/Cards/Collections/AgTechCardCollection'
import dayjs from 'dayjs'
import React from 'react'
import ContactNoteDialog from '../../dialogs/notes/ContactNoteDialog'
import { ContactNoteActionButton } from '../buttons/ContactNoteButtons'
import { ContactDetails } from '@agtech/data/contacts/ContactData'
import { ContactNote } from '@agtech/data/contacts/notes/ContactNoteData'
import AgTechCard from '../../../../components/Cards/AgTechCard'
import AgTechHeaderDetail from '../../../../components/Headers/AgTechHeaderDetail'

export type ContactNotesCardCollectionProps = {
    contactDetails: ContactDetails
    customize?: (props: AgTechCardCollectionProps<ContactNote>) => AgTechCardCollectionProps<ContactNote>
}
const ContactNotesCardCollection = (props: ContactNotesCardCollectionProps) => {
    const contactDetails = props.contactDetails;

    const collectionProps: AgTechCardCollectionProps<ContactNote> = {
        entities: Object.values(contactDetails.notes),
        card: note => (
            <AgTechCard>
                <AgTechHeaderDetail
                    header={dayjs(note.date).format("dddd - MM/DD/YYYY")}
                    detail={note.note}
                    settings={{
                        header: {
                            classes: '!text-plus'
                        },
                        content: {
                            body: () => (
                                <ContactNoteActionButton 
                                    contactId={contactDetails.contact.id}
                                    note={note}
                                />
                            )
                        }
                    }}
                />
            </AgTechCard>
            // <AgTechTitleDetailContentCard
            //     title={dayjs(note.date).format("dddd - MM/DD/YYYY")}
            //     headerContent={() => (
            //         <ContactNoteActionButton 
            //             contactId={contactDetails.contact.id}
            //             note={note}
            //         />
            //     )}
            //     onTitleClicked={e => {
            //         ContactNoteDialog.Open(e, {
            //             contactId: contactDetails.contact.id,
            //             note
            //         });
            //     }}
            //     structure={{
            //         height: 120
            //     }}
            // >
            //     <h1 className='text-base'>{note.note}</h1>
            // </AgTechTitleDetailContentCard>
        ),
        settings: {
            noRecordConfig: {
                message: 'There are no notes in the system for this contact',
                action: {
                    prompt: 'To create one, click the button below',
                    button: () => (
                        <ContactNoteDialog.Button
                            contactId={contactDetails.contact.id}
                            classes='button-highlight'
                        />
                    )
                }
            }
        }
    }

    return (
        <AgTechCardCollection
            {...(props.customize ? props.customize(collectionProps) : collectionProps)}
        />
    )
}

export default ContactNotesCardCollection